import { type EditAuditFormBackgroundData } from './types';

export const emptyFormData = Object.freeze({
  general: {
    address: {},
    occupants: {},
  },
  envelope: {
    windowTypes: {},
    doorTypes: {},
    wallTypes: {},
    roofingTypes: {},
  },
  controls: {},
  spaceHeating: {},
  spaceCooling: {},
  ventilation: {},
  domesticColdWater: {},
  domesticHotWater: {},
  lighting: {},
  other: {},
} satisfies EditAuditFormBackgroundData);
